import React, { useState, useEffect } from 'react';
import { ArchiveRestore } from 'lucide-react';
import api from '../api';

// Browse chores archived from the Chores tab and bring them back. Self-contained
// (fetches its own data) since it's the only place in the app that needs the
// archived list — no need to thread it through useChores' broader state.
const ArchivedChoresSection = ({ onRestored }) => {
    const [archived, setArchived] = useState([]);
    const [loading, setLoading] = useState(true);
    const [restoringId, setRestoringId] = useState(null);

    const fetchArchived = async () => {
        try {
            const res = await api.get('/chores/archived');
            setArchived(res.data);
        } catch (err) {
            console.error('Error fetching archived chores', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchArchived(); }, []);

    const handleRestore = async (id) => {
        setRestoringId(id);
        try {
            await api.patch(`/chores/${id}/restore`);
            await fetchArchived();
            onRestored?.();
        } catch (err) {
            alert(err.response?.data?.error || 'Failed to restore chore');
        } finally {
            setRestoringId(null);
        }
    };

    if (loading || archived.length === 0) return null;

    return (
        <div className="bg-ink-card rounded-2xl shadow-sm border border-white/10 p-5">
            <h3 className="text-xs font-mono font-medium text-ink-fg/40 uppercase tracking-wider mb-3">
                Archived Chores <span className="text-ink-fg/25">· {archived.length}</span>
            </h3>
            <div className="space-y-2">
                {archived.map(chore => (
                    <div key={chore.id} className="flex items-center justify-between gap-3 p-3 rounded-xl bg-ink-card3 border border-white/10">
                        <span className="text-sm font-medium text-ink-fg/80 truncate">{chore.title}</span>
                        <button
                            onClick={() => handleRestore(chore.id)}
                            disabled={restoringId === chore.id}
                            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-mint/10 text-mint text-xs font-bold hover:bg-mint/20 transition-colors disabled:opacity-50 flex-shrink-0"
                        >
                            <ArchiveRestore size={13} /> Restore
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ArchivedChoresSection;
